"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = require("react");
var Tooltip_1 = require("../Tooltip/Tooltip");
var Input_style_1 = __importDefault(require("./Input.style"));
/**
 * Input atom
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/atoms-inputs-input--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/atoms/Input Source}
 */
var Input = function (_a) {
    var ariaDescribedby = _a.ariaDescribedby, autoComplete = _a.autoComplete, autoGrowth = _a.autoGrowth, _b = _a.focused, focused = _b === void 0 ? false : _b, _c = _a.fontVariant, fontVariant = _c === void 0 ? 'body' : _c, hasError = _a.hasError, inputRef = _a.inputRef, maxLength = _a.maxLength, onBlur = _a.onBlur, onFocus = _a.onFocus, tooltipTextOnHover = _a.tooltipTextOnHover, useDarkPlaceholder = _a.useDarkPlaceholder, _d = _a.variant, variant = _d === void 0 ? 'primary' : _d, width = _a.width, _e = _a.withAutoFocus, withAutoFocus = _e === void 0 ? false : _e, min = _a.min, max = _a.max, step = _a.step, otherProps = __rest(_a, ["ariaDescribedby", "autoComplete", "autoGrowth", "focused", "fontVariant", "hasError", "inputRef", "maxLength", "onBlur", "onFocus", "tooltipTextOnHover", "useDarkPlaceholder", "variant", "width", "withAutoFocus", "min", "max", "step"]);
    var classes = (0, Input_style_1.default)({ fontVariant: fontVariant });
    var _f = __read((0, react_1.useState)(withAutoFocus), 2), isFocused = _f[0], setFocused = _f[1];
    var rootClasses = (0, classnames_1.default)(variant !== 'primary' && isFocused && classes.focusedOutline, variant !== 'primary' && classes.outline, variant === 'outlineOnHover' && classes.outlineOnHover, autoGrowth && classes.autoGrowthWrapper);
    var inputClasses = (0, classnames_1.default)(classes.input, useDarkPlaceholder && classes.inputWithDarkPlaceholder, autoGrowth && classes.autoGrowthElement, variant !== 'primary' && classes.outlineInput);
    var underlineClasses = variant === 'primary'
        ? (0, classnames_1.default)(classes.underline, isFocused || focused ? classes.focusedUnderline : undefined)
        : undefined;
    var onFocusInput = function (event) {
        setFocused(true);
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
    };
    var onBlurInput = function (event) {
        setFocused(false);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
    };
    if (!isFocused && tooltipTextOnHover) {
        return ((0, jsx_runtime_1.jsx)(Tooltip_1.Tooltip, __assign({ text: tooltipTextOnHover, placement: 'bottom' }, { children: (0, jsx_runtime_1.jsx)("div", { children: renderInput() }) })));
    }
    return renderInput();
    function renderInput() {
        return ((0, jsx_runtime_1.jsx)(core_1.Input, __assign({ autoFocus: withAutoFocus, classes: {
                root: rootClasses,
                disabled: classes.disabled,
                error: classes.error,
                focused: classes.focused,
                input: inputClasses,
                inputMultiline: classes.inputMultiLine,
                multiline: classes.multiline,
                underline: underlineClasses,
            }, inputComponent: 'input', inputProps: {
                'aria-describedby': ariaDescribedby,
                autoComplete: autoComplete ? 'on' : 'off',
                max: max,
                maxLength: maxLength,
                min: min,
                size: autoGrowth && (otherProps.value || !otherProps.placeholder) ? '1' : undefined,
                step: step,
            }, disableUnderline: variant !== 'primary', endAdornment: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [otherProps.endAdornment, autoGrowth && (0, jsx_runtime_1.jsx)("span", __assign({ className: classes.autoGrowthRefEle }, { children: otherProps.value }))] }), error: hasError, inputRef: inputRef, onBlur: function (event) { return onBlurInput(event); }, onFocus: function (event) { return onFocusInput(event); }, style: { width: width } }, otherProps)));
    }
};
exports.Input = Input;
